"use strict";
exports.__esModule = true;
var bignumber_js_1 = require("bignumber.js");
var createTransaction = function () { return ({
    family: "celo",
    amount: new bignumber_js_1.BigNumber(0),
    recipient: "",
    useAllAmount: false,
    fees: null,
    mode: "send",
    index: null
}); };
exports["default"] = createTransaction;
//# sourceMappingURL=js-createTransaction.js.map